import { render, staticRenderFns } from "./StatusClaimSpan.vue?vue&type=template&id=53b85e66"
import script from "./StatusClaimSpan.vue?vue&type=script&lang=js"
export * from "./StatusClaimSpan.vue?vue&type=script&lang=js"
import style0 from "./StatusClaimSpan.vue?vue&type=style&index=0&id=53b85e66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports